import { Component, Inject } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { AssessmentService } from "../assessment.service";
import { ToastrService } from "ngx-toastr";
import { NgxUiLoaderService } from "ngx-ui-loader";

@Component({
  selector: "app-assign-evaluator",
  standalone: false,
  templateUrl: "./assign-evaluator.component.html",
  styleUrl: "./assign-evaluator.component.css",
})
export class AssignEvaluatorComponent {
  searchForm: FormGroup;
  evaluators: any[] = [];
  companyId: any;
  accessToken: any;
  evaluatorSelected: any = "";

  constructor(
    public dialogRef: MatDialogRef<AssignEvaluatorComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    private assessmentService: AssessmentService,
    private toastrService: ToastrService,
    private ngxService: NgxUiLoaderService
  ) {
    this.accessToken = localStorage.getItem("accessToken");
    this.companyId = localStorage.getItem("companyId");

    this.searchForm = this.fb.group({
      type: ["tag"],
      text: [""],
    });

    console.log("data", data);
  }

  ngOnInit() {
    this.getAssignEvaluatorByStageId();
  }

  getAssignEvaluatorByStageId() {
    const payload = {
      linkId: this.data.linkId,
      stageId: this.data.stageId,
    };
    this.assessmentService
      .getAssignedEvaluator(payload, this.companyId, this.accessToken)
      .subscribe(
        (response) => {
          this.evaluators = response.message;
          // this.updateStage(updatedEvaluator);
          // this.ngxService.stop();
        },
        (error) => {
          // this.evaluationStageList = [];
          // this.toastrService.error(error.error.message);
          // this.ngxService.stop();
        }
      );
  }

  toggleSelection(item: any) {
    if (this.evaluatorSelected === item.userId) {
      this.evaluatorSelected = null; // uncheck
    } else {
      this.evaluatorSelected = item.userId; // check
      console.log("item", item);
    }
  }

  closeModal() {
    this.dialogRef.close(false);
  }

  associateEvaluator() {
    this.ngxService.start();
    const payload = {
      linkId: this.data.linkId,
      stageId: this.data.stageId,
      evaluatorId: this.evaluatorSelected,
      countryCode: this.data.countryCode,
      mobile: this.data.mobile,
    };
    this.assessmentService
      .reAssociateEvaluator(payload, this.companyId, this.accessToken)
      .subscribe(
        (response) => {
          this.ngxService.stop();
          this.toastrService.success(response.message, "Success");
          this.dialogRef.close(true);
        },
        (error) => {
          // this.evaluationStageList = [];
          this.toastrService.error(error.error.message);
          this.ngxService.stop();
        }
      );
  }
}
